import { useAuth } from "@/contexts/AuthContext";

/**
 * The service is free for everyone — any signed-in user can create trips
 * and download reports. Kept as a hook (rather than inlining `true`
 * everywhere) so billing gating can be reintroduced here later without
 * touching every call site.
 */
export function useCanCreateTrip() {
  const { user } = useAuth();
  const canCreate = Boolean(user);

  return {
    canCreate,
    canCreatePersonal: canCreate,
    hasSubscription: canCreate,
    hasCredits: canCreate,
    checked: true,
  };
}
